<template>
  <div class="forgetPassword">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="0px"
      class="demo-ruleForm"
    >
      <el-form-item prop="phone">
        <el-input
          type="text"
          v-model="ruleForm.phone"
          autocomplete="off"
          placeholder="请输入手机号"
          prefix-icon="iconfont iconqita-1shouji_1"
          :disabled="phoneInp"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="ruleForm.password"
          show-password
          autocomplete="off"
          placeholder="大小写字母、数字或特殊字符组合"
          prefix-icon="iconfont iconqita-5mima_5"
        ></el-input>
      </el-form-item>
      <el-form-item prop="confirmPwd">
        <el-input
          v-model="ruleForm.confirmPwd"
          type="password"
          show-password
          placeholder="再次确认密码"
          prefix-icon="iconfont iconqita-5mima_5"
        ></el-input>
      </el-form-item>
      <el-form-item prop="smsCode">
        <el-input
          type="text"
          v-model="ruleForm.smsCode"
          autocomplete="off"
          placeholder="请输入手机验证码"
          style="width:285px;"
          prefix-icon="iconfont iconqita-2yanzhengma_1"
        ></el-input>
        <el-button
          id="codeRef"
          ref="codeButton"
          :disabled="showGetCode"
          @click="onGetCode"
          class="defaultButtonClass"
          >{{ codeText }}</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="submitBtnLoading" @click="submitForm('ruleForm')"
          >确认</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import commonApi from 'api/common';
import registerApi from 'api/register/register.js';
import loginAPi from 'api/login.js';
import CryptoJS from 'crypto-js';

export default {
  data() {
    /* 手机号验证 */
    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        this.showGetCode = true;
        callback(new Error('请输入手机号'));
      } else if (!/^[0123456789]\d{10}$/.test(value)) {
        this.showGetCode = true;
        callback(new Error('请输入正确的手机号'));
      } else {
        this.showGetCode = false;
        callback();
        // 校验手机号是否在系统中存在
        /* commonApi
          .checkPhoneExist({
            phone: value
          })
          .then(res => {
            // 存在
            if (res.data.data) {
              this.showGetCode = false;
              callback();
            } else {
              // 不存在，无法找回密码
              this.showGetCode = true;
              callback(new Error('账号不存在，请检查后重新输入'));
            }
          }); */
      }
    };
    /* 密码验证 */
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('输入不能为空!'));
      }
      // else if (!/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{8,16}$/.test(value)) {
      //   callback(new Error('8~16位字母、数字或特殊字符组合'));
      // }
      else if (
        !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@#$%&*]).{8,}$|^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d).{8,}$|^(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%&*]).{8,}$|^(?=.*[a-z])(?=.*\\d)(?=.*[@#$%&*]).{8,}$|^(?=.*[A-Z])(?=.*\\d)(?=.*[@#$%&*]).{8,}$/.test(
          value
        )
      ) {
        callback(new Error('8~16位包含大小写字母、数字或特殊字符组合'));
      } else {
        if (this.ruleForm.confirmPwd !== '') {
          this.$refs.ruleForm.validateField('confirmPwd');
        }
        callback();
      }
    };
    /* 确认密码验证 */
    var validateConfirmPwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('输入不能为空!'));
      } else if (value !== this.ruleForm.password) {
        callback(new Error('新密码两次输入不同，请重新输入!'));
      } else {
        callback();
      }
    };
    /* 手机验证码验证 */
    var validateCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机验证码'));
      } else {
        callback();
      }
    };
    return {
      /* 步骤一表单数据 */
      ruleForm: {
        phone: '',
        smsCode: '',
        password: '',
        confirmPwd: ''
      },
      showGetCode: true,
      codeText: '获取验证码',
      countDown: 60,
      noInp: false,
      phoneInp: false,
      rules: {
        phone: [{ validator: validatePhone, trigger: 'change', required: true }],
        password: [{ validator: validatePass, trigger: 'blur', required: true }],
        confirmPwd: [{ validator: validateConfirmPwd, trigger: 'blur', required: true }],
        smsCode: [{ validator: validateCode, trigger: 'blur', required: true }]
      },
      submitBtnLoading: false
    };
  },
  methods: {
    submitForm(formName) {
      this.submitBtnLoading = true;
      this.$refs[formName].validate(valid => {
        if (!valid) {
          this.submitBtnLoading = false;
          return;
        }
        registerApi
          .findPassword({
            phone: this.ruleForm.phone,
            newPassword: this.descWord(this.ruleForm.password),
            smsCode: this.ruleForm.smsCode
          })
          .then(res => {
            if (res.data.code === 200) {
              this.submitBtnLoading = false;
              this.$message({
                message: '修改密码成功，请重新登录',
                type: 'success',
                duration: 3000,
                onClose: () => {
                  this.$router.replace('/login');
                }
              });
            }
            // else {
            //   this.$message.error(res.data.message);
            // }
          })
          .finally(() => {
            this.submitBtnLoading = false;
          });
      });
    },
    /* 倒计时 */
    countDownTime() {
      if (!this.countDown) {
        document.getElementById('codeRef').style.background = '#f56c6c';
        this.showGetCode = false;
        this.noInp = false;
        this.phoneInp = false;
        this.countDown = 60;
        this.codeText = '获取验证码';
        return;
      } else {
        this.showGetCode = true;
        this.codeText = '(' + this.countDown + 's' + ')';
        this.countDown--;
      }
      setTimeout(() => {
        this.countDownTime();
      }, 1000);
    },
    /* 获取验证码 */
    onGetCode() {
      this.noInp = true;
      this.phoneInp = true;
      this.countDownTime();

      loginAPi
        .sendSmsCode({ account: this.ruleForm.phone, typeCode: 'FP' })
        .then(res => {
          if (res.data.code === 200) {
            this.$message({
              message: '短信验证码发送成功，请注意查收',
              type: 'success'
            });
          }
        })
        .catch(err => {});
    },
    descWord(str) {
      var aseKey = 'hjiuhjsd'; //定制秘钥，长度必须为： 8/16/32位
      var message = str; //加密 DES/AES切换只需要修改 CryptoJS.AES <=> CryptoJS.DES
      var encrypt = CryptoJS.DES.encrypt(message, CryptoJS.enc.Utf8.parse(aseKey), {
        iv: CryptoJS.enc.Utf8.parse('hjiuhjsd'),
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypt.toString();
    }
  },
  watch: {
    showGetCode: function(newVal, oldVal) {
      if (!newVal && !this.noInp) {
        document.getElementById('codeRef').style.background = '#f56c6c';
      } else {
        document.getElementById('codeRef').style.background = '#dcdfe7';
      }
    }
  }
};
</script>

<style lang="less" scoped>
.forgetPassword {
  margin-top: 50px;
  display: flex;
  justify-content: center;
  /deep/.el-form-item {
    margin-bottom: 24px;
  }
  /deep/.el-input__inner::placeholder {
    color: #c0c4ce;
  }
  /deep/.el-input {
    width: 410px;
  }
  /deep/.el-button--primary {
    width: 410px;
    background: linear-gradient(90deg, #4189fd 0%, #409dff 100%);
    box-shadow: 0px 3px 6px rgba(64, 157, 255, 0.3);
    border-radius: 20px;
    margin-top: 56px;
  }
  /* 默认灰色按钮 */
  .defaultButtonClass {
    width: 115px;
    display: inline-block;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    background: #dcdfe7;
    color: #fff;
    height: 40px;
    border: 0;
    margin-left: 10px;
  }
  /* 红色按钮 */
  .greyButtonClass {
    width: 115px;
    display: inline-block;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    background: #f56c6c;
    color: #fff;
    height: 40px;
    border: 0;
    margin-left: 10px;
  }
  .greyButtonClass:hover {
    cursor: pointer;
  }
  /deep/.iconfont {
    font-size: 24px;
  }
}
</style>
